/* OnHold FAQ accordion. One item open per section at a time. */
(function () {
  function init(root) {
    var items = root.querySelectorAll('.oh-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.oh-faq-item__question');
      var answer = item.querySelector('.oh-faq-item__answer');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.oh-faq-item__question').setAttribute('aria-expanded', 'false');
          el.querySelector('.oh-faq-item__answer').setAttribute('aria-hidden', 'true');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-oh-faq]').forEach(function (root) {
      if (root.dataset.ohFaqReady) return;
      root.dataset.ohFaqReady = '1';
      init(root);
    });
  }

  initAll();
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', initAll);
})();
